import client from '../client';

const deleteCreation = async (creationID: number): Promise<void> => {
  await client.delete(`api/creations/${creationID}`);
};

export default deleteCreation;
